import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const ExportIcon: React.FC<Props> = ({
  color = "currentColor",
  ...svgProps
}) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 25)}
      {...svgProps}
      viewBox="0 0 21 16.334"
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m7.898 13.902-.8.8a3.864 3.864 0 1 1 -5.465-5.465l4.1-4.1a3.864 3.864 0 0 1 5.861 5" />
      <path d="m13.256 2.275.647-.644a3.864 3.864 0 0 1 5.465 5.465l-4.1 4.1a3.864 3.864 0 0 1 -5.86-5" />
    </SVG>
  );
};
